class HanossSaleCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = Date.parse(this.dataset.endsAt || '');
    this.snapshotExpiry = Date.parse(
      this.closest('product-price')?.querySelector('[data-hanoss-sale-expires-at]')?.dataset.hanossSaleExpiresAt || '',
    );
    this.daysOutput = this.querySelector('[data-countdown-days]');
    this.totalHours = this.dataset.hoursMode === 'total';
    this.hoursOutput = this.querySelector('[data-countdown-hours]');
    this.minutesOutput = this.querySelector('[data-countdown-minutes]');
    this.secondsOutput = this.querySelector('[data-countdown-seconds]');
    if (!Number.isFinite(this.endTime) || (!this.daysOutput && !this.totalHours) || !this.hoursOutput || !this.minutesOutput || !this.secondsOutput) return;
    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') this.tick();
    };
    document.addEventListener('visibilitychange', this.visibilityHandler);
    this.tick();
  }
  disconnectedCallback() {
    window.clearTimeout(this.timer);
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }
  tick() {
    const now = Date.now();
    const snapshotExpired = Number.isFinite(this.snapshotExpiry) && this.snapshotExpiry <= now;
    const remaining = Math.max(0, this.endTime - now);
    if (snapshotExpired || remaining === 0) {
      this.hidden = true;
      window.clearTimeout(this.timer);
      const reloadKey = `hanoss-sale-expired:${snapshotExpired ? this.snapshotExpiry : this.dataset.endsAt}`;
      let shouldReload = true;
      try {
        shouldReload = sessionStorage.getItem(reloadKey) !== '1';
        if (shouldReload) sessionStorage.setItem(reloadKey, '1');
      } catch (_) {
        shouldReload = false;
      }
      if (shouldReload) {
        window.location.reload();
      }
      return;
    }
    const total = Math.floor(remaining / 1000);
    const days = Math.floor(total / 86400);
    const hours = this.totalHours ? Math.floor(total / 3600) : Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    if (this.daysOutput) this.daysOutput.textContent = String(days);
    this.hoursOutput.textContent = String(hours);
    this.minutesOutput.textContent = String(minutes).padStart(2, '0');
    this.secondsOutput.textContent = String(seconds).padStart(2, '0');
    this.hidden = false;
    this.timer = window.setTimeout(() => this.tick(), 1000);
  }
}
if (!customElements.get('hanoss-sale-countdown')) customElements.define('hanoss-sale-countdown', HanossSaleCountdown);
